import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "chats-search-list" }
const _hoisted_2 = { class: "chats-search-list__dialogs-title" }
const _hoisted_3 = { class: "chats-search-list__dialogs-list" }
const _hoisted_4 = {
  key: 1,
  class: "empty-list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "chats-search-list__dialogs-list-item-logo" }
const _hoisted_7 = {
  key: 0,
  class: "chats-search-list__dialogs-list-item-logo-img",
  alt: "Avatar"
}
const _hoisted_8 = {
  key: 1,
  class: "chats-search-list__dialogs-list-item-logo-text"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "chats-search-list__messages-title" }
const _hoisted_11 = { class: "chats-search-list__messages-list" }
const _hoisted_12 = {
  key: 1,
  class: "empty-list"
}

import {
	computed,
	onMounted,
	ref,
	watch
} from "vue";
import {
	ChatsApi,
	SearchDialog,
	SearchMessage
} from "@/ api/ChatsApi";
import { debounce } from "lodash";
import AppLoader from "@/components/common/AppLoader.vue";
import { highlightSearchText } from "@/utils/textHelpers";
import ChatDialog from "@/components/main/chat-panel/ChatDialog.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatSearchList',
  props: {
    search: {}
  },
  emits: ["on-open-dialog", "on-open-message"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const loading = ref(true);
const isCreatingChat = ref(false)
const dialogs = ref<SearchDialog[] | null>()
const messages = ref<SearchMessage[] | null>(null)

const isListLoading = computed(() => loading.value || isCreatingChat.value)

const onFetchDialogsAndMessages = async () => {
	if (!props.search) {
		dialogs.value = null
		messages.value = null
		loading.value = false
		return
	}
	try {
		loading.value = true;
		await Promise.all([
			ChatsApi.searchDialogs(props.search),
			ChatsApi.searchMessages(props.search)
		]).then(results => {
			dialogs.value = results[0].data ?? null;
			messages.value = results[1].data ?? null;
		})
	} catch (e) {
		console.error(e)
	} finally {
		loading.value = false;
	}
}

const openDialog = async (dialog: SearchDialog) => {
	if (isCreatingChat.value) {
		return
	}

	if (!dialog.IsPotential) {
		emit('on-open-dialog', dialog, false)
		return
	}

	try {
		isCreatingChat.value = true
		const response = await ChatsApi.createChatWithYouOrOneFriend(dialog.Id)
		emit('on-open-dialog', { ...dialog, Id: response.Id, IsPotential: false }, true)
	} catch (e) {
		console.error(e)
	} finally {
		isCreatingChat.value = false
	}
}

const openMessage = (message: SearchMessage) => {
	emit('on-open-message', message)
}

const debouncedSearch = debounce(onFetchDialogsAndMessages, 500)

watch(() => props.search, () => {
	debouncedSearch()
})

const dialogsStyle = computed(() => {
	if (!dialogs.value || isListLoading.value) {
		return {
			flex: 1
		}
	}

	return {
		height: 'fit-content',
	}
})

const messagesStyle = computed(() => {
	if (!messages.value || isListLoading.value) {
		return {
			flex: 1
		}
	}

	return {
		height: 'fit-content',
	}
})

onMounted(async () => {
	await onFetchDialogsAndMessages()
})

return (_ctx: any,_cache: any) => {
  const _directive_img_fade = _resolveDirective("img-fade")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "chats-search-list__dialogs",
      style: _normalizeStyle(dialogsStyle.value)
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('chat_list_title')), 1),
      _createElementVNode("div", _hoisted_3, [
        (isListLoading.value)
          ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
          : (!dialogs.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('nothing_found')), 1))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(dialogs.value, (dialog) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "chats-search-list__dialogs-list-item",
                  key: dialog.Id,
                  onClick: ($event: any) => (openDialog(dialog))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    (dialog.PhotoLink)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_7, null, 512)), [
                          [_directive_img_fade, dialog.PhotoLink]
                        ])
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(dialog.PhotoLiter), 1))
                  ]),
                  _createElementVNode("div", {
                    class: "chats-search-list__dialogs-list-item-name",
                    innerHTML: _unref(highlightSearchText)(props.search, dialog.Name)
                  }, null, 8, _hoisted_9)
                ], 8, _hoisted_5))
              }), 128))
      ])
    ], 4),
    _createElementVNode("div", {
      class: "chats-search-list__messages",
      style: _normalizeStyle(messagesStyle.value)
    }, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('messages_label')), 1),
      _createElementVNode("div", _hoisted_11, [
        (isListLoading.value)
          ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
          : (!messages.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('nothing_found')), 1))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(messages.value, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "chats-search-list__messages-list",
                  key: message.Id
                }, [
                  _createVNode(ChatDialog, {
                    dialog: message,
                    "from-search": props.search,
                    onOnOpen: ($event: any) => (openMessage(message))
                  }, null, 8, ["dialog", "from-search", "onOnOpen"])
                ]))
              }), 128))
      ])
    ], 4)
  ]))
}
}

})